// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fampe-modal {
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 11;
  height: 100dvh;
  position: fixed;
}
.fampe-modal .close-page {
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-in-out;
}
.fampe-modal .btn-close {
  padding: 0;
  left: 12px;
  position: absolute;
}
.fampe-modal .wrapper-modal {
  right: 0;
  bottom: 0;
  z-index: 2;
  width: 93%;
  max-width: 540px;
  height: 100dvh;
  padding: 16px;
  overflow: auto;
  position: absolute;
  background-color: var(--sebrae-light-gray);
  box-shadow: 0 1px 30px 6px rgba(20, 46, 82, 0.2);
  transform: translateX(100%);
  transition: transform 0.2s ease-in-out;
}
.fampe-modal .modal-header {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}
.fampe-modal .title {
  color: var(--sebrae-dark-green);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
  padding-left: 34px;
}
.fampe-modal.open .close-page {
  background: rgba(0, 0, 0, 0.3);
}
.fampe-modal.open .wrapper-modal {
  transform: translateX(0);
}
@media screen and (min-width: 768px) {
  .fampe-modal .btn-close {
    left: 18px;
  }
  .fampe-modal .btn-close svg {
    width: 25px;
    height: 25px;
  }
  .fampe-modal .title {
    font-size: 20px;
    padding-left: 30px;
  }
  .fampe-modal .wrapper-modal {
    padding: 16px 24px;
  }
}
@media screen and (min-width: 1024px) {
  .fampe-modal .wrapper-modal {
    bottom: 50%;
    right: 50%;
    width: 99%;
    height: 95%;
    max-width: none;
    border-radius: 8px;
    transform: translate(50%, 50%) !important;
    padding: 56px 32px 32px;
    background-color: var(--sebrae-white);
  }
  .fampe-modal .wrapper-modal .btn-close {
    background: transparent;
    top: 16px;
    left: 97%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/guarantees/components/fampe-modal/index.scss"],"names":[],"mappings":"AAAA;EACE,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AACF;AACE;EACE,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;AACJ;AACE;EACE,UAAA;EACA,UAAA;EACA,kBAAA;AACJ;AACE;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;EACA,gDAAA;EACA,2BAAA;EACA,sCAAA;AACJ;AACE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACE;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AAGI;EACE,8BAAA;AADN;AAGI;EACE,wBAAA;AADN;AAKE;EACE;IACE,UAAA;EAHJ;EAII;IACE,WAAA;IACA,YAAA;EAFN;EAKE;IACE,eAAA;IACA,kBAAA;EAHJ;EAKE;IACE,kBAAA;EAHJ;AACF;AAME;EACE;IACE,WAAA;IACA,UAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;IACA,kBAAA;IACA,yCAAA;IACA,uBAAA;IACA,qCAAA;EAJJ;EAMI;IACE,uBAAA;IACA,SAAA;IACA,SAAA;EAJN;AACF","sourcesContent":[".fampe-modal {\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 11;\n  height: 100dvh;\n  position: fixed;\n\n  .close-page {\n    top: 0;\n    left: 0;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    transition: all 0.2s ease-in-out;\n  }\n  .btn-close {\n    padding: 0;\n    left: 12px;\n    position: absolute;\n  }\n  .wrapper-modal {\n    right: 0;\n    bottom: 0;\n    z-index: 2;\n    width: 93%;\n    max-width: 540px;\n    height: 100dvh;\n    padding: 16px;\n    overflow: auto;\n    position: absolute;\n    background-color: var(--sebrae-light-gray);\n    box-shadow: 0 1px 30px 6px rgba(20, 46, 82, 0.2);\n    transform: translateX(100%);\n    transition: transform 0.2s ease-in-out;\n  }\n  .modal-header {\n    margin-bottom: 24px;\n    display: flex;\n    align-items: center;\n  }\n  .title {\n    color: var(--sebrae-dark-green);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 1.2;\n    padding-left: 34px;\n  }\n\n  &.open {\n    .close-page {\n      background: rgba(0, 0, 0, 0.3);\n    }\n    .wrapper-modal {\n      transform: translateX(0);\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .btn-close {\n      left: 18px;\n      svg {\n        width: 25px;\n        height: 25px;\n      }\n    }\n    .title {\n      font-size: 20px;\n      padding-left: 30px;\n    }\n    .wrapper-modal {\n      padding: 16px 24px;\n    }\n  }\n\n  @media screen and (min-width: 1024px) {\n    .wrapper-modal {\n      bottom: 50%;\n      right: 50%;\n      width: 99%;\n      height: 95%;\n      max-width: none;\n      border-radius: 8px;\n      transform: translate(50%, 50%) !important;\n      padding: 56px 32px 32px;\n      background-color: var(--sebrae-white);\n\n      .btn-close {\n        background: transparent;\n        top: 16px;\n        left: 97%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
